<script lang="ts" setup>
type RTextSize = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

const props = withDefaults(
  defineProps<{
    type?:
      | 'primary'
      | 'secondary'
      | 'success'
      | 'warning'
      | 'danger'
      | 'info'
      | 'contrast'
    size?: RTextSize
    bold?: boolean
    ellipsis?: boolean
    rows?: number
  }>(),
  {
    size: 'h1',
    type: undefined,
    bold: false,
    rows: 1
  }
)

const tagClasses = {
  'myz-text': true,
  [`myz-text--${props.type}`]: props.type !== undefined,
  [`myz-text--${props.size}`]: props.size !== undefined,
  'myz-text--bold': props.bold,
  'myz-text--ellipsis': props.ellipsis
}
</script>

<template>
  <component
    :is="size"
    :class="tagClasses"
    :style="{
      '-webkit-line-clamp': rows || 1
    }"
  >
    <slot />
  </component>
</template>
